export default "__VITE_ASSET__HoqHfdea__"